import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetReportFields } from '../../hooks/react-query/useUserData';

import ReportComponent from '../../components/reports/reportComponent';
import { ReportsSkeletion } from '../../components/elements/skeletions/skeletions';
import { NoDataFound } from '../../components/elements/noDataFound';
import Container from '../../components/elements/container';
import { DateRangePicker } from '../../components/elements/datePicker/datePicker';
import { LeftArrow } from '../../icons';

export const Reports = () => {
  const navigate = useNavigate();

  const [date, setDate] = useState({
    from: new Date(),
    to: new Date(),
  });
  const { data, isLoading } = useGetReportFields();
  if (isLoading) {
    return (
      <Container className="flex flex-col gap-6">
        <ReportsSkeletion />
      </Container>
    );
  }

  if (!data) {
    return (
      <Container>
        <NoDataFound />
      </Container>
    );
  }

  return (
    <Container className="flex flex-col gap-6">
      <div className="flex max-lg:flex-col lg:justify-between gap-6 lg:items-center">
        <div className="flex  items-center">
          <button type="button" className='px-2' onClick={() => navigate('/dashboard')}>
            <LeftArrow className={'lg:w-[24px] lg:h-[24px] w-[16px] h-[16px] stroke-black'}/>
          </button>
          <h2>Αναφορές</h2>
        </div>
        <DateRangePicker
          showDeleteIcon={false}
          selected={date}
          className="bg-primary text-white"
          iconClass={'stroke-white'}
          handleDate={(value) => setDate(value)}
        />
      </div>

      <ul className="grid lg:grid-cols-3 gap-5">
        {Object.keys(data.data).map((key) => (
          <ReportComponent
            listItem={data.data[key]}
            listKey={key}
            key={key}
            date={date}
          />
        ))}
      </ul>
    </Container>
  );
};

export default Reports;
